'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _reactPerfectScrollbar = require('react-perfect-scrollbar');

var _reactPerfectScrollbar2 = _interopRequireDefault(_reactPerfectScrollbar);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _difference = require('ramda/src/difference');

var _difference2 = _interopRequireDefault(_difference);

var _reselect = require('reselect');

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _onlinepbxButtonLink = require('./onlinepbx-button-link');

var _onlinepbxButtonLink2 = _interopRequireDefault(_onlinepbxButtonLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ArrowsIcon = function () {
  function ArrowsIcon(props) {
    return _react2['default'].createElement(
      'svg',
      props,
      _react2['default'].createElement('path', {
        d: 'M15 7.5l-5 5-5-5',
        stroke: '#A8A4B9',
        strokeLinecap: 'round',
        strokeLinejoin: 'round'
      })
    );
  }

  return ArrowsIcon;
}();

ArrowsIcon.defaultProps = {
  width: '20',
  height: '20',
  viewBox: '0 0 20 20',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
};

var CheckIcon = function () {
  function CheckIcon(props) {
    return _react2['default'].createElement(
      'svg',
      props,
      _react2['default'].createElement('path', {
        d: 'M40 14L18 36 8 26',
        stroke: '#00BB20',
        strokeWidth: '2',
        strokeLinecap: 'round',
        strokeLinejoin: 'round'
      })
    );
  }

  return CheckIcon;
}();

CheckIcon.defaultProps = {
  width: '48',
  height: '48',
  viewBox: '0 0 48 48',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
};

var CrossIcon = function () {
  function CrossIcon(props) {
    return _react2['default'].createElement(
      'svg',
      props,
      _react2['default'].createElement('path', {
        d: 'M15 5L5 15M5 5l10 10',
        stroke: '#A8A4B9',
        strokeLinecap: 'round',
        strokeLinejoin: 'round'
      })
    );
  }

  return CrossIcon;
}();

CrossIcon.defaultProps = {
  width: '20',
  height: '20',
  viewBox: '0 0 20 20',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
};


var getResultName = (0, _reselect.createSelector)(function (selectedOptions) {
  return selectedOptions;
}, function (selectedOptions, options) {
  return options;
}, function (selectedOptions, options, namesFields) {
  return namesFields;
}, function (selectedOptions, options, _ref) {
  var allSelectName = _ref.allSelectName,
      fieldOptionId = _ref.fieldOptionId,
      fieldOptionName = _ref.fieldOptionName;
  return !(0, _difference2['default'])(fieldOptionId ? options.map(function (option) {
    return option[fieldOptionId];
  }) : options, selectedOptions).length && allSelectName || (fieldOptionId ? options.filter(function (option) {
    return selectedOptions.includes(option[fieldOptionId]);
  }).map(function (option) {
    return option[fieldOptionName];
  }) : options.filter(function (option) {
    return selectedOptions.includes(option);
  })).join(', ');
});

var metaKeysArr = ['Enter', 'NumpadEnter', 'Tab', 'Escape'];

/** Props:
 *       disabled,
 *       defaultText,
 *       allSelectName,
 *       label,
 *       selectedOptions,
 *       options,
 *       onBlur,
 *       placeholder,
 *       className,
 *       fieldOptionName,
 *       fieldOptionId,
 *       onKeyDown,
 *       onKeyDownClose
 *       emptyFilterText,
 *       handleSelected,
 *       isEmpty,
 *       isCloseModal,
 *       selectedAll,
 *       unselectedAll,
 *       unselectedAllText,
 *       selectedAllText,
 *       buttons
 */

var OnlinepbxMultiSelect = function (_React$Component) {
  _inherits(OnlinepbxMultiSelect, _React$Component);

  function OnlinepbxMultiSelect(props) {
    _classCallCheck(this, OnlinepbxMultiSelect);

    var _this = _possibleConstructorReturn(this, (OnlinepbxMultiSelect.__proto__ || Object.getPrototypeOf(OnlinepbxMultiSelect)).call(this, props));

    _this.state = {
      isModal: false,
      search: '',
      position: null
    };
    _this.domNode = document.createElement('div');
    _this.renderModal = _this.renderModal.bind(_this);
    _this.handleUpdate = _this.handleUpdate.bind(_this);
    _this.openModal = _this.openModal.bind(_this);
    _this.isCursor = true;
    return _this;
  }

  _createClass(OnlinepbxMultiSelect, [{
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        var _this2 = this;

        this.handleUpdate();
        var containers = document.querySelectorAll('.scrollbar__dark');
        containers.forEach(function (container) {
          return container.addEventListener('scroll', _this2.handleUpdate);
        });
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentWillUnmount',
    value: function () {
      function componentWillUnmount() {
        var _this3 = this;

        var containers = document.querySelectorAll('.scrollbar__dark');
        containers.forEach(function (container) {
          return container.removeEventListener('scroll', _this3.handleUpdate);
        });
        document.body.contains(this.domNode) && document.body.removeChild(this.domNode);
      }

      return componentWillUnmount;
    }()
  }, {
    key: 'componentDidUpdate',
    value: function () {
      function componentDidUpdate(prevProps, prevState) {
        if (this.state.isModal && !prevState.isModal) {
          document.body.appendChild(this.domNode);
        } else if (!this.state.isModal && prevState.isModal) {
          document.body.removeChild(this.domNode);
          typeof this.props.handleCloseModal === 'function' && this.props.handleCloseModal();
          this.setState({ search: '' });
        }
      }

      return componentDidUpdate;
    }()
  }, {
    key: 'openModal',
    value: function () {
      function openModal() {
        this.buttonGeneral && this.buttonGeneral.click();
      }

      return openModal;
    }()
  }, {
    key: 'closeModal',
    value: function () {
      function closeModal() {
        this.setState({ isModal: false });
      }

      return closeModal;
    }()
  }, {
    key: 'handleUpdate',
    value: function () {
      function handleUpdate() {
        this.setState({
          isModal: false,
          position: this.select && this.select.getBoundingClientRect()
        });
      }

      return handleUpdate;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _this4 = this,
            _classNames4;

        var _props = this.props,
            disabled = _props.disabled,
            _props$defaultText = _props.defaultText,
            defaultText = _props$defaultText === undefined ? 'По умолчанию' : _props$defaultText,
            _props$allSelectName = _props.allSelectName,
            allSelectName = _props$allSelectName === undefined ? '' : _props$allSelectName,
            _props$label = _props.label,
            label = _props$label === undefined ? '' : _props$label,
            _props$selectedOption = _props.selectedOptions,
            selectedOptions = _props$selectedOption === undefined ? [] : _props$selectedOption,
            _props$options = _props.options,
            options = _props$options === undefined ? [] : _props$options,
            _onBlur = _props.onBlur,
            placeholder = _props.placeholder,
            _props$className = _props.className,
            className = _props$className === undefined ? 'onlinepbx__lib__multi' : _props$className,
            _props$fieldOptionNam = _props.fieldOptionName,
            fieldOptionName = _props$fieldOptionNam === undefined ? '' : _props$fieldOptionNam,
            _props$fieldOptionId = _props.fieldOptionId,
            fieldOptionId = _props$fieldOptionId === undefined ? '' : _props$fieldOptionId,
            _onKeyDown = _props.onKeyDown,
            onKeyDownClose = _props.onKeyDownClose;

        var resultName = options.length ? getResultName(selectedOptions, options, { allSelectName: allSelectName, fieldOptionId: fieldOptionId, fieldOptionName: fieldOptionName }) : '';
        var input = void 0;
        return [_react2['default'].createElement(
          'div',
          {
            key: 'multiselect_wrapper',
            ref: function () {
              function ref(node) {
                if (node && !_this4.select) {
                  _this4.forceUpdate();
                }
                _this4.select = node || _this4.select;
              }

              return ref;
            }(),
            onMouseEnter: function () {
              function onMouseEnter() {
                _this4.isCursor = false;
              }

              return onMouseEnter;
            }(),
            onMouseLeave: function () {
              function onMouseLeave() {
                _this4.isCursor = true;
              }

              return onMouseLeave;
            }(),
            className: (0, _classnames2['default'])('' + String(className), _defineProperty({}, String(className) + '__top', this.state.position && this.state.position.y >= document.body.clientHeight / 2.4))
          },
          label && _react2['default'].createElement(
            'div',
            { className: (0, _classnames2['default'])(String(className) + '__label', _defineProperty({}, String(className) + '__label__disabled', disabled)) },
            label
          ),
          _react2['default'].createElement(
            'div',
            { className: String(className) + '__container' },
            this.state.isModal && _react2['default'].createElement('input', {
              disabled: disabled,
              onBlur: function () {
                function onBlur(evt) {
                  if (_this4.isCursor) {
                    typeof _onBlur === 'function' && _onBlur(evt);
                    _this4.setState({ isModal: false });
                  }
                }

                return onBlur;
              }(),
              autoFocus: true,
              ref: function () {
                function ref(node) {
                  if (node && !_this4.input) {
                    _this4.forceUpdate();
                  }
                  _this4.input = node || _this4.input;
                }

                return ref;
              }(),
              className: (0, _classnames2['default'])(String(className) + '__selected', _defineProperty({}, String(className) + '__selected__active', this.state.isModal)),
              placeholder: placeholder,
              onChange: function () {
                function onChange(evt) {
                  return _this4.setState({ search: evt.target.value });
                }

                return onChange;
              }(),
              value: this.state.search,
              onKeyDown: function () {
                function onKeyDown(evt) {
                  if (onKeyDownClose && metaKeysArr.includes(evt.key)) {
                    _this4.setState({ isModal: false });
                  }
                  return typeof _onKeyDown === 'function' && _onKeyDown(evt, selectedOptions);
                }

                return onKeyDown;
              }()
            }) || _react2['default'].createElement(
              'button',
              {
                disabled: disabled,
                ref: function () {
                  function ref(node) {
                    if (node && !_this4.buttonGeneral) {
                      _this4.forceUpdate();
                    }
                    _this4.buttonGeneral = node || _this4.buttonGeneral;
                  }

                  return ref;
                }(),
                title: resultName || '',
                className: (0, _classnames2['default'])(String(className) + '__selected', (_classNames4 = {}, _defineProperty(_classNames4, String(className) + '__selected__label', !label), _defineProperty(_classNames4, String(className) + '__selected__active', this.state.isModal), _defineProperty(_classNames4, String(className) + '__selected__disabled', disabled), _classNames4)),
                onClick: function () {
                  function onClick() {
                    _this4.handleUpdate();
                    _this4.setState({ isModal: !!options.length && !_this4.state.isModal });
                  }

                  return onClick;
                }()
              },
              _react2['default'].createElement(
                'div',
                { className: (0, _classnames2['default'])(String(className) + '__selected__text', _defineProperty({}, String(className) + '__selected__text__disabled', disabled)) },
                resultName || defaultText
              )
            ),
            this.state.search && _react2['default'].createElement(
              'button',
              { className: String(className) + '__selected__cross' },
              _react2['default'].createElement(CrossIcon, {
                onMouseEnter: function () {
                  function onMouseEnter() {
                    _this4.isCursor = false;
                  }

                  return onMouseEnter;
                }(),
                onMouseLeave: function () {
                  function onMouseLeave() {
                    _this4.isCursor = true;
                  }

                  return onMouseLeave;
                }(),
                onClick: function () {
                  function onClick() {
                    _this4.input.value = '';
                    _this4.input.focus();
                    _this4.setState({ search: '' });
                  }

                  return onClick;
                }(),
                className: String(className) + 'cross'
              })
            ) || _react2['default'].createElement(ArrowsIcon, {
              onClick: function () {
                function onClick() {
                  if (disabled) return undefined;
                  _this4.handleUpdate();
                  _this4.setState({ isModal: !!options.length && !_this4.state.isModal });
                }

                return onClick;
              }(),
              className: (0, _classnames2['default'])('onlinepbx__lib__arrows', {
                onlinepbx__lib__arrows__active: this.state.isModal
              })
            })
          )
        ), this.state.isModal && _reactDom2['default'].createPortal(this.renderModal(options, fieldOptionId, fieldOptionName, selectedOptions), this.domNode)];
      }

      return render;
    }()
  }, {
    key: 'renderModal',
    value: function () {
      function renderModal(options, fieldOptionId, fieldOptionName, selectedOptions) {
        var _this5 = this;

        var _props2 = this.props,
            _props2$emptyFilterTe = _props2.emptyFilterText,
            emptyFilterText = _props2$emptyFilterTe === undefined ? 'Не найдено' : _props2$emptyFilterTe,
            handleSelected = _props2.handleSelected,
            _props2$isEmpty = _props2.isEmpty,
            isEmpty = _props2$isEmpty === undefined ? true : _props2$isEmpty,
            isCloseModal = _props2.isCloseModal,
            _onBlur2 = _props2.onBlur,
            selectedAll = _props2.selectedAll,
            unselectedAll = _props2.unselectedAll,
            _props2$unselectedAll = _props2.unselectedAllText,
            unselectedAllText = _props2$unselectedAll === undefined ? 'Снять все' : _props2$unselectedAll,
            _props2$selectedAllTe = _props2.selectedAllText,
            selectedAllText = _props2$selectedAllTe === undefined ? 'Выбрать всё' : _props2$selectedAllTe,
            _props2$className = _props2.className,
            className = _props2$className === undefined ? 'onlinepbx__lib__multi' : _props2$className,
            buttons = _props2.buttons;

        var height = className === 'onlinepbx__lib__multi' ? 5 : 0;
        var optionsKeysFiltered = options.filter(function (option) {
          return typeof (fieldOptionName ? option[fieldOptionName] : option) === 'string' ? (fieldOptionName ? option[fieldOptionName] : option).toLowerCase().includes(_this5.state.search.toLowerCase()) : true;
        });
        return _react2['default'].createElement(
          'div',
          {
            style: {
              width: this.select && this.select.offsetWidth,
              top: this.state.position && this.state.position.y >= document.body.clientHeight / 2.4 ? 'auto' : this.state.position.top + this.select.offsetHeight + height,
              bottom: this.state.position && this.state.position.y >= document.body.clientHeight / 2.4 ? document.body.clientHeight - this.state.position.bottom + this.select.offsetHeight + height : 'auto',
              left: this.state.position.x
            },
            tabIndex: 1,
            onMouseEnter: function () {
              function onMouseEnter() {
                _this5.isCursor = false;
              }

              return onMouseEnter;
            }(),
            onMouseLeave: function () {
              function onMouseLeave() {
                _this5.isCursor = true;
              }

              return onMouseLeave;
            }(),
            onBlur: function () {
              function onBlur(evt) {
                if (_this5.isCursor) {
                  setTimeout(function () {
                    return _this5.setState({ isModal: false });
                  }, 200);
                  typeof _onBlur2 === 'function' && _onBlur2(evt);
                }
              }

              return onBlur;
            }(),
            className: String(className) + '__modal'
          },
          isEmpty && optionsKeysFiltered.length === 0 && _react2['default'].createElement(
            'div',
            { className: String(className) + '__option__empty' },
            emptyFilterText
          ),
          _react2['default'].createElement(
            _reactPerfectScrollbar2['default'],
            { className: String(className) + '__modal__scrollbar scrollbar__dark' },
            optionsKeysFiltered.map(function (option) {
              return _react2['default'].createElement(
                'button',
                {
                  key: fieldOptionId ? option[fieldOptionId] : option,
                  className: String(className) + '__option',
                  onClick: function () {
                    function onClick(evt) {
                      return handleSelected(fieldOptionId ? option[fieldOptionId] : option);
                    }

                    return onClick;
                  }()
                },
                _react2['default'].createElement(
                  'div',
                  { className: String(className) + '__option__text' },
                  fieldOptionName ? option[fieldOptionName] : option
                ),
                _react2['default'].createElement(CheckIcon, {
                  className: (0, _classnames2['default'])(String(className) + '__check', _defineProperty({}, String(className) + '__check__active', selectedOptions.includes(fieldOptionId ? option[fieldOptionId] : option)))
                })
              );
            })
          ),
          (selectedAll || unselectedAll || buttons) && _react2['default'].createElement(
            'div',
            { className: String(className) + '__buttons' },
            _react2['default'].createElement(
              'div',
              { className: String(className) + '__button' },
              _react2['default'].createElement(_onlinepbxButtonLink2['default'], {
                onClick: function () {
                  function onClick(evt) {
                    if (isCloseModal) {
                      _this5.setState({ isModal: false });
                    }
                    typeof selectedAll === 'function' && selectedAll(evt);
                  }

                  return onClick;
                }(),
                text: selectedAllText })
            ),
            _react2['default'].createElement(
              'div',
              { className: String(className) + '__button' },
              _react2['default'].createElement(_onlinepbxButtonLink2['default'], {
                onClick: function () {
                  function onClick(evt) {
                    if (isCloseModal) {
                      _this5.setState({ isModal: false });
                    }
                    typeof unselectedAll === 'function' && unselectedAll(evt);
                  }

                  return onClick;
                }(),
                text: unselectedAllText })
            )
          )
        );
      }

      return renderModal;
    }()
  }]);

  return OnlinepbxMultiSelect;
}(_react2['default'].Component);

exports['default'] = OnlinepbxMultiSelect;